import Request from './../../request';
import { IOrderTruckResourceProps, IOrderTruckResourceShortProps } from '../../../props/orders/trucks';
import moment from 'moment';

// import props

const OrderTruckService = {
    retrieve: async (orderId: string, qs?: string): Promise<IOrderTruckResourceShortProps[]> => {
        try {
            const results = await Request.get(`/api/orders/${orderId}/trucks?${qs || ""}`);
            return results;
        } catch (e) {
            throw (e);
        }
    },
    new: async (orderId: string, data: FormData): Promise<IOrderTruckResourceShortProps> => {
        try {
            const result = await Request.post(`/api/orders/${orderId}/trucks`, data, 'multipart/form-data');
            return result;
        } catch (e) {
            throw (e);
        }
    },
    update: async (orderId: string, truckId: string, data: FormData): Promise<IOrderTruckResourceShortProps> => {
        try {
            const result = await Request.post(`/api/orders/${orderId}/trucks/${truckId}?_method=PUT`, data, 'multipart/form-data');
            return result;
        } catch (e) {
            throw (e);
        }
    },
    get: async (orderId: string, truckId: string): Promise<IOrderTruckResourceProps> => {
        try {
            const result = await Request.get(`/api/orders/${orderId}/trucks/${truckId}`);
            return result;
        } catch (e) {
            throw (e);
        }
    },
    delete: async (orderId: string, truckId: string): Promise<void> => {
        try {
            await Request.delete(`/api/orders/${orderId}/trucks/${truckId}`);
            return;
        } catch (e) {
            throw (e);
        }
    },
    downloadPackingList: async (truckId: string, format?: string, name?: string) => {
        try {
            const result = await Request.download(`/api/truck/${truckId}/packing_list/download?format=${format ?? 'docx'}`);

            const data = new Blob([result.data], { type: result.headers["content-type"] });
            const url = window.URL.createObjectURL(data);
            const linkTag = document.createElement('a');
            linkTag.href = url;
            linkTag.setAttribute('download', `${"PackingList " + (name ?? moment().format("DDMMYYYY"))}.${format ?? 'docx'}`);
            document.body.appendChild(linkTag);
            linkTag.click();
            linkTag.remove();
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);

            return result;
        } catch (e) {
            throw (e);
        }
    },
    documents: {
        retrieve: async (orderId: string, truckId: string): Promise<any[]> => {
            try {
                const result = await Request.get(
                    `/api/orders/${orderId}/trucks/${truckId}/documents`
                );
                return result.data ?? result;
            } catch (e) {
                throw e;
            }
        },
        upload: async (orderId: string, truckId: string, data: FormData) => {
            try {
                const result = await Request.post(
                    `/api/orders/${orderId}/trucks/${truckId}/documents`,
                    data,
                    'multipart/form-data'
                );
                return result;
            } catch (e) {
                throw e;
            }
        },
        delete: async (orderId: string, truckId: string, data: FormData): Promise<void> => {
            try {
                await Request.post(
                    `/api/orders/${orderId}/trucks/${truckId}/delete_documents`,
                    data
                );
                return;
            } catch (e) {
                throw e;
            }
        },
        download: async (orderId: string, truckId: string, documentId: string) => {
            try {
                const result = await Request.getBlob(
                    `/api/orders/${orderId}/trucks/${truckId}/documents/${documentId}/download`
                );
                return result;
            } catch (e) {
                throw e;
            }
        },
    }
}

export default OrderTruckService;
